import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { actionTypes } from "../context/reducer";
import { useStateValue } from "../context/StateProvider";
import "./Success.scss";

let orderInformation = {
  name: "it did not work",
  orderNumber: 1,
  billingName: "this is not working",
  address: "this is not a real addres in Montreal, canada",
  phone: "647-912-3871",
  email: "jehanne@hodges.com",
};

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const Success = () => {
  const [orderData, setOrderData] = useState();
  const [{ cart }, dispatch] = useStateValue();


  // const handleAddCart = () => {
  //   dispatch({
  //     type: actionTypes.ADD_TO_CART,
  //     product: {
  //       productId: productID,
  //       quantity: 1,
  //       labelId: uuidv4(),
  //       labelPNG
  //     }
  //   });
  // };

  let queryParams = useQuery();

  const id = queryParams.get("id");
  // console.log("id",  id);

  useEffect(() => {
    
    dispatch({
      type: actionTypes.EMPTY_CART
    });
    const getResult = async () => {
      const response = await axios(
        `${process.env.REACT_APP_API_BASE_URL}/order/${id}`
        );
        setOrderData(response.data);
      // return response;
    }
    getResult();

    // const result =  ;
    return () => {};
  }, []);

  // const { orderProcessed } = data;
  // console.log("orderData", orderData ? orderData.orderProcessed.customerDetails : "");

  if (orderData) {
    const custDetails = orderData.orderProcessed.customerDetails;
    // const aptLength = custDetails.Appartment.length;
    orderInformation = {
      name: `${custDetails["First Name"]} ${custDetails["Last Name"]} `,
      orderNumber: id,
      billingName: `${custDetails["First Name"]} ${custDetails["Last Name"]} `,
      address: `${custDetails.Address}${custDetails.Apartment ? custDetails.Apartment : ""}, ${custDetails.City}, ${custDetails.Province}, ${
        custDetails["Postal Code"]
      } Canada`,
      phone: custDetails["Phone Number"],
      email: custDetails["Email"],
    };
    // console.log(orderInformation)
  }

  return (
    <main className="success-page">
      {!orderData ? <div className="loading-spinner"><div></div><div></div><div></div><div></div></div> :
       <div>
        <h1>Your order is complete!</h1>
        <p className="orderid">Order ID: {orderInformation.orderNumber}</p>
        <br/>
        <p>Thank you {orderInformation.name} for ordering from It's My Wine!</p>
        <p>
          You will receive an email confirmation at {orderInformation.email}{" "}
          shortly!
        </p>
        <p>Your order will arrive in 10-15 days.</p>
        <br/>
        <p>Shipping Information:</p> 
        <p>{orderInformation.billingName}</p>
        <p>{orderInformation.address}</p>
        <p>Phone: {orderInformation.phone} </p>
        <br/>
        <p>
          If you have any questions or concerns please contact us at
          itsmywine@gmail.com
        </p>
       </div> 
      }

    </main>
  );
};

export default Success;
